"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bar = exports.BarTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var BarTypes;
(function (BarTypes) {
    BarTypes["PRIMARY"] = "primary";
    BarTypes["SECONDARY"] = "secondary";
    BarTypes["SUCCESS"] = "success";
    BarTypes["DANGER"] = "danger";
    BarTypes["WARNING"] = "warning";
    BarTypes["INFO"] = "info";
    BarTypes["LIGHT"] = "light";
    BarTypes["DARK"] = "dark";
    BarTypes["OUTLINE_PRIMARY"] = "outline-primary";
    BarTypes["OUTLINE_SECONDARY"] = "outline-secondary";
    BarTypes["OUTLINE_SUCCESS"] = "outline-success";
    BarTypes["OUTLINE_DANGER"] = "outline-danger";
    BarTypes["OUTLINE_WARNING"] = "outline-warning";
    BarTypes["OUTLINE_INFO"] = "outline-info";
    BarTypes["OUTLINE_LIGHT"] = "outline-light";
    BarTypes["OUTLINE_DARK"] = "outline-dark";
})(BarTypes = exports.BarTypes || (exports.BarTypes = {}));
/**
 * @category UI-components
 * @param props
 */
var Bar = function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("bar")
        .pmod(props.type || BarTypes.PRIMARY)
        .bem;
    var style = Object.assign({}, {
        width: props.width + "px",
        height: (props.height || "4") + "px"
    }, props.style || {});
    return ((0, jsx_runtime_1.jsx)("span", { id: props.id, className: "".concat(cls, " ").concat(props.className || ""), style: style }));
};
exports.Bar = Bar;
